<template>
    <div class="issue-track-module">
        <!-- 基本信息卡片 -->
        <div class="basic-card" :style="{ backgroundImage: `url(${basic.bgUrl})` }">
            <div class="basic-title">
                <span class="dot"></span>
                基本信息
            </div>
            <div class="basic-row">调研问卷 {{ basic.surveyTitle }}</div>
            <div class="basic-row">走访轮次 {{ basic.roundDesc }}</div>
            <div class="basic-row">检查门店 {{ basic.storeName }}</div>
            <div class="basic-row flex">
                <span>报告得分 {{ basic.score }}</span>
                <span class="level-tag" :class="getScoreClass(basic.score)">{{ getScoreLabel(basic.score) }}</span>
            </div>
        </div>

        <!-- 标签切换 -->
        <div class="issue-tabs">
            <van-tabs v-model="active" @change="onTabChange" animated>
                <van-tab :title="`待反馈(${counts.pending})`" name="pending" />
                <van-tab :title="`已反馈(${counts.feedbacked})`" name="feedbacked" />
                <van-tab :title="`已完成(${counts.completed})`" name="completed" />
            </van-tabs>
        </div>

        <!-- 列表 -->
        <div class="issue-list">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="20" :immediate-check="false">
                    <div class="issue-item" v-for="item in filteredIssues" :key="item.rectifyId">
                        <div class="item-head">
                            <img class="avatar" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="" />
                            <div class="meta">
                                <div class="name">{{ item.inspectorName }}</div>
                                <div class="time">{{ item.createDate }}</div>
                            </div>
                        </div>
                        <div class="desc">{{ item.explanation }}</div>
                        <div class="img-grid" v-if="item.fileInfoList && item.fileInfoList.length > 0">
                            <div v-for="(n, k) in item.fileInfoList" :key="n.id || n.url || k" class="img-ph" @click="openPreview(item.fileInfoList, k)">
                                <img v-if="isImage(n.url)" :src="n.url" alt="">
                                <video v-else-if="isVideo(n.url)" :src="n.url" muted playsinline></video>
                            </div>
                        </div>
                        <div class="check-row">
                            <span class="label">检查项：</span>
                            <span class="value" :class="{ ellipsis: !item.expanded }">{{ item.questionName }}</span>
                        </div>
                        <div class="expand" v-if="isLongText(item.questionName)" @click="toggleExpand(item)">{{ item.expanded ? '收起' : '展开' }}</div>
                        <div class="detail-cell" @click="toDetail(item)">
                            <span>详情</span>
                            <span class="arrow">›</span>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <MediaPreview v-model="showPreview" :list="previewList" :start-index="previewStartIndex" />
    </div>
</template>

<script>
    import { Toast } from 'vant'
    import request from '@/utils/request'
    import { getUserLogin } from '@/api/home'
    import MediaPreview from './components/MediaPreview.vue'
    import { isImage, isVideo } from '@/utils/index.js'
    export default {
        name: 'issueTrack',
        components: { MediaPreview },
        data() {
            return {
                active: 'pending',
                counts: { pending: 0, feedbacked: 0, completed: 0 },
                basic: {
                    surveyTitle: '',
                    roundDesc: '',
                    storeName: '',
                    storeCode: '',
                    score: ''
                },
                filteredIssues: [],
                refreshing: false,
                loading: false,
                finished: false,
                page: 1,
                pageSize: 10,
                total: 0,
                itemTitleLimit: 42,
                showPreview: false,
                previewList: [],
                previewStartIndex: 0
            }
        },
        created() {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            // this.activeName = this.$route.query.tabType
            // this.postId = getCookie('postId') || localStorage.getItem('postId');

            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {

                this.getDataList()
                this.getStoreInfo();
            })

        },

        methods: {
            isImage,
            isVideo,
            isLongText(s) {
                const str = s || ''
                let len = 0
                for (const ch of str) {
                    len += /[^\x00-\xff]/.test(ch) ? 2 : 1
                }
                return len >= this.itemTitleLimit
            },
            getStoreInfo() {
                request({
                    url: `/rectify-audit/queryByQuestionnaireId?id=${this.$route.query.assessmentId}`,
                    method: "get",
                })
                    .then((res) => {
                        this.basic = {
                            surveyTitle: res.data.questionnaireName,
                            roundDesc: res.data.visitRound,
                            storeName: res.data.storeName,
                            storeCode: res.data.storeCode,
                            score: res.data.score,
                            bgUrl: res.data.bgUrl
                        };
                    })
            },
            onRefresh() {
                this.page = 1
                this.finished = false;
                this.loading = true;
                this.filteredIssues = [];
                this.refreshing = false;
                this.getDataList()
            },
            onLoad() {
                this.getDataList();
            },
            getDataList() {
                let params = {
                    id: this.$route.query.assessmentId || 1,
                    page: this.page,
                    limit: this.pageSize,
                    rectifyStatus: this.active === 'pending' ? 0 : this.active === 'feedbacked' ? 1 : 2
                }
                request({
                    url: `/rectify-audit/page-query`,
                    method: "get",
                    params: params
                }).then((res) => {
                    this.filteredIssues = this.page == 1 ? res.data.pageResponse.list.map(item => ({
                        ...item,
                        status: item.rectifyStatus,
                        expanded: false,
                    })) : this.filteredIssues.concat(res.data.pageResponse.list.map(item => ({
                        ...item,
                        avatar: item.headImg,
                        expanded: false
                    })));
                    this.page++;
                    console.log(this.page)
                    this.total = res.data.pageResponse.total;
                    this.counts = {
                        pending: res.data.pending,
                        feedbacked: res.data.feedbacked,
                        completed: res.data.competed
                    }
                    // 手动清除 Toast
                    Toast.clear();

                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    if (this.filteredIssues.length >= this.total) {
                        this.finished = true;
                    }
                });
            },
            onTabChange(name) {
                this.active = name
                this.onRefresh()
            },
            toggleExpand(item) {
                item.expanded = !item.expanded
            },
            openPreview(list, idx) {
                const safe = Array.isArray(list) ? list : []
                this.previewList = safe.map(x => ({ type: x.type == 1 ? 'image' : 'video', url: x.url }))
                this.previewStartIndex = Number(idx) || 0
                this.showPreview = true
            },
            toDetail(item) {
                this.$router.push({ name: 'issueDetail', query: { id: item.rectifyId } })
            },
            // 走访轮次转换 1转化第1轮
            formatRound(value) {
                return '第' + value + '轮'
            },
            getScoreLabel(score) {
                const s = Number(score)
                if (isNaN(s) || s == '') return ''
                if (s < 60) return '不及格'
                if (s <= 70) return '一般'
                if (s < 85) return '良好'
                return '优秀'
            },
            getScoreClass(score) {
                const s = Number(score)
                if (isNaN(s) || s == '') return ''
                if (s < 60) return 'score-red'
                if (s <= 70) return 'score-yellow'
                if (s < 85) return 'score-orange'
                return 'score-green'
            }
        }
    }
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
        display: none;
    }

    .issue-track-module {
        background: #f9fafc;
        min-height: 100vh;
        font-family: PingFangSC, PingFang SC;
    }

    .basic-card {
        margin: 30px;
        // background: linear-gradient(180deg, #F6FAFF 0%, #E9F2FF 100%);
        border-radius: 4px;
        padding: 20px;
        background-size: 100%;
        background-position: 0 0;
        background-repeat: no-repeat;
    }

    .basic-title {
        display: flex;
        align-items: center;
        color: #35434c;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 20px;
    }

    .basic-title .dot {
        width: 20px;
        height: 20px;
        background: #fff;
        border-radius: 50%;
        margin-right: 8px;
        border: 5px solid #4375C9;
    }

    .basic-row {
        color: #35434c;
        font-size: 26px;
        line-height: 36px;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 20px;
    }

    .basic-row.flex {
        display: flex;
        align-items: center;
    }

    .level-tag {
        margin-left: 12px;
        height: 40px;
        line-height: 40px;
        padding: 0 14px;
        border-radius: 20px;
        font-size: 24px;
    }

    .issue-tabs {
        margin: 10px 0;
    }

    :deep(.van-tabs__wrap) {
        display: flex;
        justify-content: center;
    }

    :deep(.van-tab) {
        flex: none !important;
        width: 210px !important;
        height: 64px !important;
        line-height: 64px !important;
        margin: 0 12px;
        color: #a0acb5;
        font-size: 28px;
    }

    :deep(.van-tab.van-tab--active) {
        border-radius: 30px;
        color: #35434C;
    }

    :deep(.van-tabs__line) {
        background: #2FD0D5;
    }

    // :deep(.van-list__finished-text) {
    //     height: 280px !important;
    // }

    .issue-list {
        padding: 0 0 18px;
        height: calc(100vh - 480px);
        overflow: auto;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .issue-item {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);
        padding: 30px;
        margin-bottom: 14px;
    }

    .item-head {
        display: flex;
        align-items: center;
    }

    .avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        object-fit: cover;
    }

    .meta {
        margin-left: 12px;
    }

    .name {
        color: #35434c;
        font-size: 26px;
    }

    .time {
        color: #a0acb5;
        font-size: 24px;
        margin-top: 6px;
    }

    .desc {
        color: #35434c;
        font-size: 26px;
        margin: 14px 0;
    }

    .img-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        margin-bottom: 30px;
    }

    .img-ph {
        width: 150px;
        height: 150px;
        border-radius: 4px;
    }

    .img-ph img,
    .img-ph video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .check-row {
        display: flex;
        // align-items: center;
        color: #35434c;
    }

    .label {
        color: #a0acb5;
        font-size: 28px;
    }

    .value {
        font-size: 28px;
        flex: 1;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .expand {
        color: #0D73E4;
        font-size: 28px;
        margin-top: 20px;
        text-align: right;
    }

    .detail-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
        padding-top: 12px;
        border-top: 1px solid #eef1f3;
        color: #A0ACB5;
        font-size: 28px;
    }

    .arrow {
        color: #A0ACB5;
        font-size: 48px;
    }

    .van-tabs__wrap {
        width: 100%;
        background-color: #FFF;
    }

    /* 不及格 - 红色 */
    .score-red {
        color: #F65252;
        border: 2px solid #F65252;
    }

    /* 一般 - 黄色 */
    .score-yellow {
        color: #E9D81A;
        border: 2px solid #E9D81A;
    }

    /* 良好 - 橙色 */
    .score-orange {
        color: #F7A63B;
        border: 2px solid #F7A63B;
    }

    /* 优秀 - 绿色 */
    .score-green {
        color: #2FD0D5;
        border: 2px solid #2FD0D5;
    }
</style>
